import { RootState } from '@core/Store'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface GeoLocation {
  latitude?: number
  longitude?: number
  isoCode: string
  accuracy: number | null
  timestamp: string
  mocked?: boolean
  isPreciseAccuracy?: boolean
  isInside?: boolean
}

const geoLocationInitialState: GeoLocation = {
  latitude: undefined,
  longitude: undefined,
  isoCode: '',
  accuracy: null,
  timestamp: '',
  mocked: undefined,
  isPreciseAccuracy: undefined,
  isInside: undefined,
}

const geoLocationSlice = createSlice({
  name: 'geo-location',
  initialState: geoLocationInitialState,
  reducers: {
    setCoords(
      state,
      {
        payload: { latitude, longitude, isoCode, accuracy, timestamp, mocked, isPreciseAccuracy },
      }: PayloadAction<GeoLocation>
    ) {
      state.latitude = latitude
      state.longitude = longitude
      state.isoCode = isoCode
      state.accuracy = accuracy
      state.timestamp = timestamp
      state.mocked = mocked
      state.isPreciseAccuracy = isPreciseAccuracy
    },
    setIsInside(state, { payload }: PayloadAction<boolean>) {
      state.isInside = payload
    },
  },
})

export const { setCoords, setIsInside } = geoLocationSlice.actions

export default persistReducer({ key: 'geo-location', storage }, geoLocationSlice.reducer)

export const getCoords = (state: RootState) => state.geoLocation
